import { render, staticRenderFns } from "./ItemUsuari.vue?vue&type=template&id=2c3b5099&"
import script from "./ItemUsuari.vue?vue&type=script&lang=js&"
export * from "./ItemUsuari.vue?vue&type=script&lang=js&"
import style0 from "./ItemUsuari.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports